export const CPUserProfileMock = {};

export const HierarchyMock = {
	department: '',
	categories: [],
};

export const LOGIN_RESP_MOCK = {
	error: null,
	firstName: 'Mohit',
	lastName: 'Vijay',
	catManUser: false,
	personaAccessCodes: ['2000'],
	loginId: 'procter.gamble700@gmail.com',
	email: 'mohit.vijay@not.colpal.com',
	persona_access_codes: ['2001'],
	phoneNumber: '0000000000',
	contactCountryCode: null,
	contactPhoneCountry: null,
	userType: 'EXTERNAL',
	companyId: '3021i000002ZK7SAAW',
	isAtCompanyLevel: true,
	companyName: 'THE PROCTER & GAMBLE COMPANY',
	realmId: 'kr_temp_realm',
	domain: null,
	retailLinkUserId: 'abcdef1',
	userLoginTime: 1644854716205,
	userLastTokenUsedTime: 1644854721949,
	glns: ['0035000000002', '0052742000008', '0851397007000'],
	legalVendors: [],
	products: [
		{
			code: 'CUSTOMER_PERCEPTION',
			name: 'Customer Perception',
			redirectUrl: 'https://dev.scintilla.com/customerperception',
		},
		{
			code: 'CHANNEL_PERFORMANCE',
			name: 'Channel Performance',
			redirectUrl: 'https://dev.scintilla.com/channelperformance',
		},
		{
			code: 'SHOPPER_BEHAVIOR',
			name: 'Shopper Behavior',
			redirectUrl:
				'https://dev.scintilla.com/shopperbehavior/dh.clientportal.web/web',
		},
	],
	authz: null,
	iat: 1644854721,
};
